import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

export default function RecuperarPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError('Ingresá tu email'); return; }

    setLoading(true);
    setError('');
    try {
      await authService.forgotPassword(email.trim());
      setEnviado(true);
    } catch (err) {
      // Siempre mostrar mensaje genérico para no revelar si el email existe
      setEnviado(true);
    } finally {
      setLoading(false);
    }
  };

  if (enviado) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-10 max-w-md w-full text-center">
          <div className="text-5xl mb-4">📧</div>
          <h2 className="text-2xl font-bold text-white mb-3">Revisá tu email</h2>
          <p className="text-gray-400 mb-2">
            Si existe una cuenta con <span className="text-white font-medium">{email}</span>, vas a recibir un link para restablecer tu contraseña.
          </p>
          <p className="text-gray-500 text-sm mb-8">El link expira en 1 hora. Revisá también la carpeta de spam.</p>
          <button
            onClick={() => navigate('/app')}
            className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <button onClick={() => navigate('/')}>
            <img
              src="/logorentiacompletonaranjablanco.png"
              alt="Rentia"
              className="h-12 w-auto object-contain mx-auto"
            />
          </button>
        </div>

        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 shadow-xl">
          <h1 className="text-2xl font-bold text-white mb-1">Recuperar contraseña</h1>
          <p className="text-gray-400 text-sm mb-6">
            Ingresá tu email y te enviamos un link para crear una nueva contraseña.
          </p>

          {error && (
            <div className="mb-4 bg-red-900/40 border border-red-500 text-red-300 rounded-lg px-4 py-3 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-gray-300 text-sm block mb-1.5">Email de tu cuenta</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="juan@inmobiliaria.com"
                disabled={loading}
                className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Enviando...' : 'Enviar instrucciones'}
            </button>
          </form>

          <p className="text-center text-gray-500 text-sm mt-6">
            <button onClick={() => navigate('/app')} className="text-[#ed6f28] hover:underline">
              ← Volver al inicio de sesión
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
